<template>
  <div class="page-wrapper" >
    <search-list  @findData="flushData"></search-list>
  </div>
</template>

<script>
  import SearchList from './components/SearchList'
  import {flushHouseData} from "../../../api/projectSearch";

  export default {
    name: "flushmanage",
    components: {
      SearchList,
    },
    data() {
      return {
        searchData: {
          page:1,
          limit:10,
          moduleFid:'',
          type:''
        },

      }
    },
    methods:{
      flushData(value){
        this.searchData=Object.assign(value)
        flushHouseData(this.searchData).then(res=>{
          this.success()
        }).catch(res=>{
          this.error()
        })
      },
      success () {
        this.$Message.success('刷新成功');
      },
      error () {
        this.$Message.error('刷新失败');
      }
    },
    created(){
    }
  }
</script>

<style scoped>

</style>
